import Explore from '../../components/home/Explore'

const Home = () => {
  return (
    <>
        <Explore/>
    </>
  )
}

export default Home